module.exports = __webpack_public_path__ + "static/media/character-03.fe143c03.png";